import contentPublications from '@/shared/lib/constants/publications';
import { FilterState } from '@/shared/lib/filter/model/types';
import { Select } from '@/shared/ui/select';

export interface IContentPublicationSelectProps {
  value: FilterState['contentPublication'];
  onChange: (value: FilterState['contentPublication']) => void;
  disabled?: boolean;
}

export default function ContentPublicationSelect({
  value: currentValue = 0,
  onChange,
  disabled,
}: IContentPublicationSelectProps) {
  const convertedCurrent = contentPublications.filter(
    ({ value }) => currentValue === value
  );

  return (
    <div className="min-w-[230px]">
      <Select
        placeholder="Publication"
        options={contentPublications.map(({ value, label }) => ({
          value,
          label,
        }))}
        current={convertedCurrent.length ? convertedCurrent[0] : undefined}
        onChange={(data) => {
          onChange(data.value as number);
        }}
        disabled={disabled}
      />
    </div>
  );
}
